// reason: trouble determining what the types should be, in this case, as it
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentType, lazy, LazyExoticComponent } from 'react';

import { get } from 'radash';

/**
 *
 * @param {() => Promise<*>} loader
 * @param {string} [name="default"]
 * @param loader
 * @returns
 */
export const lazyNamed = (
  loader: () => Promise<{ [name: string]: any }>,
  name = 'default'
): LazyExoticComponent<ComponentType<any>> => lazy(() => loader().then((module) => ({ default: get(module, name) })));
